export const USER_GET_TOKEN_SUCCESS = 'USER_GET_TOKEN_SUCCESS'
export const USER_GET_TOKEN_FAIL = 'USER_GET_TOKEN_FAIL'


export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL'

export const USER_LOGOUT_REQUEST = 'USER_LOGOUT_REQUEST'
export const USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS'
export const USER_LOGOUT_FAIL = 'USER_LOGOUT_FAIL'

export const MENTOR_REGISTER_REQUEST = 'MENTOR_REGISTER_REQUEST'
export const MENTOR_REGISTER_SUCCESS = 'MENTOR_REGISTER_SUCCESS'
export const MENTOR_REGISTER_FAIL = 'MENTOR_REGISTER_FAIL'
export const MENTOR_REGISTER_RESET = 'MENTOR_REGISTER_RESET'

export const STUDENT_REGISTER_REQUEST = 'STUDENT_REGISTER_REQUEST'
export const STUDENT_REGISTER_SUCCESS = 'STUDENT_REGISTER_SUCCESS'
export const STUDENT_REGISTER_FAIL = 'STUDENT_REGISTER_FAIL'
export const STUDENT_REGISTER_RESET = 'STUDENT_REGISTER_RESET'

export const USER_PROFILE_REQUEST = 'USER_PROFILE_REQUEST'
export const USER_PROFILE_SUCCESS = 'USER_PROFILE_SUCCESS'
export const USER_PROFILE_FAIL = 'USER_PROFILE_FAIL'
export const USER_PROFILE_RESET = 'USER_PROFILE_RESET'

export const USER_PROFILE_UPDATE_REQUEST = 'USER_PROFILE_UPDATE_REQUEST'
export const USER_PROFILE_UPDATE_SUCCESS = 'USER_PROFILE_UPDATE_SUCCESS'
export const USER_PROFILE_UPDATE_FAIL = 'USER_PROFILE_UPDATE_FAIL'
export const USER_PROFILE_UPDATE_RESET = 'USER_PROFILE_UPDATE_RESET'